import React, { useContext, useState, useEffect } from 'react';
import { useMatch, useNavigate, useSearchParams } from 'react-router-dom';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '../MenuIcon';
import Drawer from '@mui/material/Drawer';
import Button from '@mui/material/Button';
import Link from '@mui/material/Link';
import { useTheme } from '@mui/styles';
import { GlobalContext } from '../../context/GlobalState';
import CampusList from './CampusList';
import TourAreaList from './TourAreaList';
import Filters from './Filters';

export default function Panel() {
  const {
    store: { campus, selectedMarkers },
    setCampus,
    toggleMarker,
  } = useContext(GlobalContext);

  const theme = useTheme();
  const isMaps = useMatch('/maps');
  const isTours = useMatch('/maps/:tour/:area');
  const navigate = useNavigate();

  const [drawerOpen, setDrawerOpen] = useState(false);
  const [desktop, setDesktop] = useState(false);

  let [, setSearchParams] = useSearchParams();

  const setResponsiveness = () => {
    if (window.innerWidth > theme.breakpoints.values.sm) {
      setDesktop(true);
      setDrawerOpen(true);
    } else {
      setDesktop(false);
      setDrawerOpen(false);
    }
  };

  // Update browser url query
  useEffect(() => {
    if (isMaps) {
      const searchParams = selectedMarkers.length
        ? `?campus=${campus}&markers=${selectedMarkers.join(',')}`
        : `?campus=${campus}`;
      setSearchParams(searchParams);
    }
  }, [campus, selectedMarkers]);

  useEffect(() => {
    setResponsiveness();
    window.addEventListener('resize', () => setResponsiveness());
    return () => {
      window.removeEventListener('resize', () => setResponsiveness());
    };
  }, []);

  let PanelContent;
  if (isMaps) {
    PanelContent = (
      <>
        <CampusList campus={campus} setCampus={setCampus} />
        <Filters
          selectedMarkers={selectedMarkers}
          toggleMarker={toggleMarker}
        />
      </>
    );
  }
  if (isTours) {
    PanelContent = (
      <>
        <TourAreaList />
        <Button
          variant='contained'
          color='secondary'
          onClick={() => {
            const searchParams = selectedMarkers.length
              ? `?campus=${campus}&markers=${selectedMarkers.join(',')}`
              : `?campus=${campus}`;
            navigate('/maps/' + searchParams);
            if (!desktop) {
              setDrawerOpen(false);
            }
          }}
          sx={{
            margin: '14px 9px 0 9px',
            width: 'calc(100% - 18px)',
            borderRadius: '8px',
            boxShadow: '0 1px 6px 0 rgba(54,54,54,0.29)',
          }}
        >
          Close 360 Tour
        </Button>
      </>
    );
  }

  return (
    <Box
      sx={{
        width: ['100%', '320px'],
        position: [null, 'fixed'],
        zIndex: 1,
        top: '16px',
        left: '16px',
        borderRadius: '10px',
        boxShadow: '0 0 15px 3px rgba(0,0,0,0.11)',
      }}
    >
      <AppBar
        sx={{
          position: [null, 'relative'],
          borderRadius: [null, '10px 10px 0 0'],
        }}
      >
        <Toolbar>
          <img
            src={process.env.PUBLIC_URL + '/RRC-Polytech-White-Logo.svg'}
            alt='RRC Polytech Logo'
            width='204'
            height='35'
          />
          {!desktop && (
            <IconButton
              size='large'
              edge='end'
              color='inherit'
              aria-label='menu'
              onClick={() => setDrawerOpen((s) => !s)}
            >
              <MenuIcon isActive={drawerOpen} />
            </IconButton>
          )}
        </Toolbar>
      </AppBar>

      <Drawer
        anchor='top'
        open={drawerOpen}
        variant={desktop ? 'persistent' : 'temporary'}
      >
        <Box className='panel-content'>{PanelContent}</Box>
        <Box
          sx={{
            display: 'flex',
            'align-items': 'center',
            color: '#C5CED2',
            background: '#f1f6fa',
            'font-weight': '500',
          }}
        >
          <Link
            href='/'
            underline='none'
            sx={{
              'padding-right': '4px !important',
            }}
          >
            Visit our full website
          </Link>
          <span>&bull;</span>
          <Link
            href='/legal/accessibility/'
            underline='none'
            sx={{
              'padding-left': '4px !important',
            }}
          >
            Accessibility
          </Link>
        </Box>
      </Drawer>
    </Box>
  );
}
